import axios from "axios";
import store from "../redux/store";
import { API_BASE_URL } from "./apiConfig";

// Sends uncaught browser errors to the Task Manager, which turns them into a developer task (deduplicated and rate
// limited on the server). Only the page path and a short message are sent: no data from the page, no stack.
// Server (5xx) errors are reported by the backend itself, so API failures are not repeated here.
let sent = 0;
const seen = new Set();
const IGNORE = [/ResizeObserver loop/i, /^Script error\.?$/i, /Loading chunk .* failed/i, /Network ?Error/i, /Failed to fetch/i, /AbortError/i, /chrome-extension|moz-extension/i];

function send(message) {
  try {
    const token = store.getState().auth?.token;
    const text = String(message || "").slice(0, 300);
    if (!token || !text || sent >= 5 || seen.has(text) || IGNORE.some((rx) => rx.test(text))) return;
    seen.add(text); sent += 1;
    axios.post(`${API_BASE_URL}/api/tasks/system-errors`, { page_path: window.location.pathname, message: text }, { headers: { Authorization: `Bearer ${token}` }, timeout: 8000 }).catch(() => {});
  } catch (e) { /* reporting must never break the app */ }
}

export function installErrorReporter() {
  window.addEventListener("error", (ev) => send(ev && (ev.message || (ev.error && ev.error.message))));
  window.addEventListener("unhandledrejection", (ev) => send(ev && ev.reason && (ev.reason.message || String(ev.reason))));
}
